import { createContext, useContext, useEffect, useState } from "react";

import api from "../api";
import { cookies } from "../services/cookie";

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [loading, setLoading] = useState(true);
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [user, setUser] = useState(null);

  // /me: access token хүчингүй бол interceptor refresh хийгээд дахин оролдоно
  const fetchMe = async () => {
    const res = await api.me();
    if (res?.status === 200) {
      setUser(res.data.data);
      setIsAuthenticated(true);
      return true;
    }
    cookies.remove("access_token", { path: "/" });
    setUser(null);
    setIsAuthenticated(false);
    return false;
  };

  // Апп ачаалахад нэг удаа: cookie-д refresh байвал session сэргэнэ
  useEffect(() => {
    fetchMe().finally(() => setLoading(false));
  }, []);

  const setAuth = async (access_token) => {
    cookies.set("access_token", access_token, { path: "/" });
    return fetchMe();
  };

  const removeAuth = () => {
    cookies.remove("access_token", { path: "/" });
    setUser(null);
    setIsAuthenticated(false);
  };

  if (loading) return null;

  return (
    <AuthContext.Provider
      value={{
        removeAuth,
        isAuthenticated,
        user,
        setUser,
        setAuth,
        fetchMe,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error("useAuth must be used within an AuthProvider");
  }
  return context;
};
